import { popover } from "../lib/popover.js";
import { modal } from "../lib/modal.js";
import { sideNavigationSubmenuToggle } from "../lib/submenu-toggle.js";
import { scrollTopButton } from "../lib/scroll-top.js";
import { marquee } from "../lib/marquee.js";
import { loadSprites } from "./load-sprites.js";
import { rowMenuInit } from "./row-menu-init.js";
import { phoneInputMaskInit } from "../lib/inputmask-init.js";
import { contactFormInit } from "../lib/contact-form.js";
import { lazyLoadImages } from "../lib/lazy-load-images.js";
import {memoryStorage} from "../lib/memory-storage.js";

export function appInit() {
    rowMenuInit();
    loadSprites();
    popover();
    modal({
        onOpen(params) {
            phoneInputMaskInit(params.$root);
            lazyLoadImages(params.$root);
            memoryStorage.set("modal-data", {
                action: params.action
            });
        }
    });
    sideNavigationSubmenuToggle();
    scrollTopButton();
    marquee();
    phoneInputMaskInit();
    contactFormInit();
    lazyLoadImages();
}